import { Link } from "react-router-dom";
import { observer } from "mobx-react";
import React, { useState } from "react";
import useStores from "../../../../utils/useStores";

import Button from "@mui/material/Button";
import { SidebarSubjectHeader } from "../Sidebar/SidebarSubjectHeader";
import { modquizPaths } from "../../index";

import { QuizObject } from "../../../../store/modquiz/quiz_objects/quiz-object";
import "./style.css";

import ObjectList from "./ObjectList";
import { SidebarObjectListItemWrapper } from "./SidebarObjectListItemWrapper";

type SidebarObjectProps = {
    subject: any;
    quiz_objects: Map<string, QuizObject>;
    subjectHashKey: string;
    createObject: Function;
    hasCreateAccess: boolean;
    fromQuizzer: boolean;
};

const defaultImage = () => "/images/random-subject-2.jpg";

const imageURL = (imageErrored: boolean, image_url: string) => {
    if (imageErrored) {
        return defaultImage();
    }

    if (image_url) {
        return image_url;
    }

    return defaultImage();
};

const SidebarObject = observer(
    ({
        createObject,
        fromQuizzer,
        hasCreateAccess,
        quiz_objects,
        subject,
        subjectHashKey
    }: SidebarObjectProps) => {
        const rootStore = useStores();

        // TODO: Change objects to load from rootstaore as nested.
        let quiz_object_ids = new Array();

        const [error, setError] = useState(false);
        const [sorting, setSorting] = useState(false);
        const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

        const pushQuizObject = (id: string) => {
            if (!quiz_object_ids.includes(id)) quiz_object_ids.push(id);
        };

        const onSortEnd = ({ oldIndex, newIndex }: any) => {
            setSorting(false);
            if (oldIndex === newIndex) return;

            if (newIndex == quiz_object_ids.length) {
                return rootStore.subjectStore.moveObject(
                    subject.hash_key,
                    quiz_object_ids[oldIndex],
                    undefined
                );
            }
            return rootStore.subjectStore.moveObject(
                subject.hash_key,
                quiz_object_ids[oldIndex],
                quiz_object_ids[newIndex]
            );
        };

        const onSortStart = ({ node, index, collection, isKeySorting }: any) => {
            setSorting(true);
        };

        let sortingClass = "";
        if (sorting) {
            sortingClass = "sorting";
        }

        let sortedQuizObjects = new Array();

        if (rootStore.subjectStore.subjects.get(subjectHashKey)) {
            sortedQuizObjects = rootStore.subjectStore.subjects.get(
                subjectHashKey
            ).sortedQuizObjects;
        }

        return (
            <div className={"sidebar object-list-sidebar " + sortingClass}>
                <SidebarSubjectHeader subject={subject} />
                <button
                    className="sidebar-mobile-toggle"
                    type="button"
                    aria-expanded={mobileMenuOpen}
                    onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
                >
                    {mobileMenuOpen ? "Hide cards" : "Cards and quiz"}
                </button>
                <div className={`sidebar-mobile-content${mobileMenuOpen ? " is-open" : ""}`}>
                    <div className="row">
                        <div className="col-10 offset-1">
                            <Link to={modquizPaths.quizSubject(`${subjectHashKey}`)}>
                                <Button
                                    className="wide-button"
                                    variant="contained"
                                    color="primary"
                                >
                                    {fromQuizzer ? "Back to Quizzer" : "Quiz"}
                                </Button>
                            </Link>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-12">
                            <br />
                            <b className="sidebar-header">Cards</b>
                            {hasCreateAccess && (
                                <span className="pull-right" style={{marginRight: "10px", marginTop: "-10px"}}>
                                    <Link to={modquizPaths.newQuizObject(subjectHashKey)}>
                                        <Button variant="text" size="small">+</Button>
                                    </Link>
                                </span>
                            )}

                            <br />
                            <ObjectList
                                onSortEnd={onSortEnd}
                                onSortStart={onSortStart}
                                pressDelay={300}
                                // @ts-ignore - SortableContainer HOC doesn't fully expose custom props in types
                                quiz_objects={quiz_objects}
                                sortedQuizObjects={sortedQuizObjects}
                                subjectHashKey={subjectHashKey}
                                hasCreateAccess={hasCreateAccess}
                                createObject={createObject}
                                pushQuizObject={pushQuizObject}
                            />
                            {subject.canEdit && (
                                <SidebarObjectListItemWrapper>
                                    <Link to={modquizPaths.newQuizObject(subjectHashKey)}>
                                        <Button variant="text" size="small">New Card</Button>
                                    </Link>
                                </SidebarObjectListItemWrapper>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        );
    }
);

export default SidebarObject;
